<!--
 * @Author: your name
 * @Date: 2021-08-30 11:44:34
 * @LastEditTime: 2021-09-10 11:05:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-hero-bump-website-front\src\components\NewsList.vue
-->
<template>
  <section class="new-list-block">
    <div class="header">
      <a href="/" :class="['home', store.globalData.lang]"></a>
      <div class="title">{{ $t('news_title') }}</div>
    </div>
    <section>
      <ul class="list">
        <router-link
          tag="li"
          :to="{ path: '/gameNews/newsDetail', query: { id: item.id } }"
          class="item"
          v-for="(item, index) in dataSource"
          :key="index"
        >
          <div class="list_pic">
            <img :src="item.cover_url" alt="" />
          </div>
          <div class="lside">
            <p class="time">{{ item.create_time }}</p>
            <h1 class="title">{{ item.title }}</h1>
            <p class="info" v-html="item.desc"></p>
          </div>
        </router-link>
        <div class="nulls" v-if="!dataSource.length">{{ $t('news_null') }}</div>
      </ul>
    </section>
    <div class="flip" v-if="dataSource.length">
      <span>{{ $t('record', { total: total }) }}</span>
      <span>{{ page }}/{{ pagecount }}</span>
      <span><a href="javascript:;" @click="turnPage('pre')">{{
        $t('pre')
      }}</a></span>
      <span>|</span>
      <span><a href="javascript:;" @click="turnPage('next')">{{
        $t('next')
      }}</a></span>
      <!-- <span><a
        href="javascript:;"
        @click="turnPage('finally', type)"
      >尾页</a></span> -->
      <span
        v-if="store.globalData.lang === 'zhCHT'"
      >第
        <input
          type="text"
          ref="input"
          v-model="jumpPage"
          @keyup.enter="flip()"
        />
        页</span>
      <span
        v-if="store.globalData.lang === 'zhEn'"
      >To
        <input
          type="text"
          ref="input"
          v-model="jumpPage"
          @keyup.enter="flip()"
        />
      </span>
    </div>
  </section>
</template>

<script>
import { userAgent } from '../utils/index.js'
import { getInformationCenterList } from '../api/index.js'
export default {
  name: 'NewsList',
  data () {
    return {
      total: 0,
      page_now: 1,
      pagecount: 0,
      count: 1,
      langMatch: {
        zhCHT: 'zh-cn',
        zhEn: 'en'
      },
      page: 1,
      jumpPage: '',
      dataSource: []
    }
  },
  mounted () {
    this.Search()
  },
  computed: {
    mobile () {
      return userAgent().mobile
    },
    pageSize () {
      return this.mobile ? 3 : 4
    }
  },
  methods: {
    // 查询资讯
    async Search () {
      const param = {
        page: this.page,
        page_size: this.pageSize,
        lang: this.langMatch[this.store.globalData.lang]
      }
      const res = await getInformationCenterList(param)
      if (res.code === 1) {
        this.dataSource = res.data.Data
        this.total = res.data.TotalCount
        const index = this.total % this.pageSize
        this.pagecount =
          parseInt(this.total / this.pageSize) + (index === 0 ? 0 : 1)
      }
    },
    turnPage (type) {
      if (this.page === this.pagecount && type === 'next') {
        return
      }
      if (this.page === 1 && type !== 'next') {
        return
      }
      type === 'next' ? this.page++ : this.page--
      this.Search()
    },
    flip () {
      const pages =
        this.total % 4 === 0 ? this.total / 4 : Math.floor(this.total / 4) + 1
      if (parseInt(this.jumpPage) <= pages && parseInt(this.jumpPage) > 0) {
        this.page = parseInt(this.jumpPage)
      } else if (parseInt(this.jumpPage) > pages) {
        this.page = pages
        this.jumpPage = pages
      } else {
        this.page = 1
        this.jumpPage = 1
      }
      this.Search()
    }
  },
  watch: {
    'store.globalData.lang' () {
      this.Search()
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../styles/mixin.less');
.fun(@multiple) {
  .nulls {
    margin-top: 100px;
    margin-left: 40px;
  }
  .header {
    height: 80px;
    border-bottom: #c2c2c2 1px solid;
    margin-top: 32px;
    .flex(around);
    .home {
      width: 63px * @multiple;
      height: 49px * @multiple;
      .mixin-lang-bg('/assets/pc/{lang}/home.png');
      background-size: 100%;
      &.zhEn {
        width: 37px * @multiple;
        height: 46px * @multiple;
      }
    }
    .title {
      flex: 1;
      text-align: center;
      font-size: 32px * @multiple;
      font-weight: bold;
      font-stretch: normal;
      color: #6c65ea;
    }
  }
  .list {
    width: 100%;
    .item {
      height: 210px * @multiple;
      border-bottom: #c2c2c2 1px solid;
      transition: all 0.4s ease;
      cursor: pointer;
      .flex(@center);
      &:hover {
      }
      .list_pic {
        width: 258px * @multiple;
        height: 160px * @multiple;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .lside {
        flex: 1;
        text-align: left;
        margin-left: 20px;
        p {
          padding: 6px 0;
          &.time {
            font-weight: bold;
          }
        }
        .title {
          font-weight: bold;
          font-size: 24px;
        }
        &:hover {
          color: #6c65ea;
        }
      }
    }
  }
  .flip {
    margin-top: 70px * @multiple;
    span {
      color: #676464;
      margin-right: 10px;
      font-size: 18px;
      a {
        color: #676464;
        font-size: 18px;
        text-decoration: none;
      }
      input {
        width: 60px * @multiple;
        height: 22px;
        border: 1 solid #ddd;
        text-align: center;
        outline: none;
      }
    }
  }
}
.fun(1);
@media screen and (max-width: 1500px) {
  .fun(0.65);
}
@media screen and (max-width: 750px) {
  .nulls {
    margin-top: 1rem;
    margin-left: 0.4rem;
  }
  .new-list-block {
    width: 100%;
    height: 11rem;
    background: url('../assets/app/bg4.png');
    background-size: cover;
  }
  .header {
    // margin-top: 0.25rem!important;
    height: 1.12rem;
    width: 92%;
    margin: 0 auto;
    .flex(around);
    .home {
      width: 0.73rem;
      height: 0.59rem;
      &.zhEn {
        width: 0.37rem;
        height: 0.46rem;
      }
    }
    .title {
      font-size: 0.36rem;
      margin-right: 0.42rem;
    }
  }
  .list {
    width: 93%;
    margin: 0 auto;
    font-weight: bold;
    .item {
      height: 2.64rem;
      &:hover {
        margin-left: 0;
      }
      .list_pic {
        width: 2.58rem;
        height: 1.6rem;
      }
      .lside {
        margin-left: 0.24rem;
        p {
          padding: 0.12rem 0;
          &.info {
            margin-top: 0.16rem;
          }
        }
        .title {
          font-size: 0.32rem;
        }
      }
    }
  }
  .flip {
    margin-top: 0.8rem;
    span {
      margin-right: 0.2rem;
      font-size: 0.24rem;
      a {
        font-size: 0.24rem;
      }
      input {
        width: 0.62rem;
        height: 0.4rem;
      }
    }
  }
}
</style>
